import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from './useDictionary';

export const useGeneralDictionary = () => {
  return useDictionary(Dictionary, DICTIONARY.General);
};
